'use strict';
import isString from 'lodash/isString';

export class TimerDurationStatus {
  static NORMAL = new TimerDurationStatus('NORMAL');
  static NEAR_DUE = new TimerDurationStatus('NEAR_DUE');
  static OVER_DUE = new TimerDurationStatus('OVER_DUE');

  /**
   * @param {String} val
   */
  constructor(val) {
    this.val = val;
  }

  static valueOf(val) {
    if (isString(val))
      switch (val) {
        case TimerDurationStatus.NORMAL.val:
          return TimerDurationStatus.NORMAL;
        case TimerDurationStatus.NEAR_DUE.val:
          return TimerDurationStatus.NEAR_DUE;
        case TimerDurationStatus.OVER_DUE.val:
          return TimerDurationStatus.OVER_DUE;
      }
    else if (val instanceof TimerDurationStatus)
      return val;
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/utils/TimerDurationStatus.js